/**
 * Adapts raw push notification and news article data into a unified NotificationItem format
 */

/**
 * @typedef {Object} NotificationItem
 * @property {string} id
 * @property {"news"|"push"} type
 * @property {string} title
 * @property {string} [body]
 * @property {string} [image]
 * @property {string} [link]
 * @property {string} createdAt
 * @property {boolean} isRead
 * @property {string} [originalId] - The raw ID from the backend
 */

const adaptPushNotification = notification => ({
  id: `push-${notification.ID}`,
  type: "push",
  title: notification.title,
  body: notification.body,
  image: null,
  link: notification.link || null,
  createdAt: notification.CreatedAt || notification.timestamp,
  isRead: notification.isRead,
  originalId: notification.ID,
});

const adaptNewsArticle = article => ({
  id: `news-${article.id}`,
  type: "news",
  title: article.title,
  body: null,
  image: article.image || null,
  link: `/article/${generateSlug(article.title)}`,
  createdAt: article.created_at,
  isRead: true,
  originalId: article.id,
});

const generateSlug = title =>
  title
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-");

const adaptNotificationsFeed = (pushNotifications = [], newsArticles = []) => {
  const pushItems = pushNotifications.map(adaptPushNotification);
  const newsItems = newsArticles.map(adaptNewsArticle);

  return [...pushItems, ...newsItems].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
};

export {adaptNotificationsFeed, adaptNewsArticle, adaptPushNotification};
